import React from 'react';

// Cultural SVG scene illustrations — one triptych per language.
// Used as atmospheric backgrounds in the dashboard header.

export function SceneMadrid() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <rect width="320" height="120" fill="#1a0f08"/>
      <ellipse cx="160" cy="130" rx="200" ry="50" fill="rgba(220,100,20,0.12)"/>
      {([[20,14],[60,8],[110,19],[180,11],[240,7],[290,17],[150,5],[80,24],[310,12],[10,25]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.9" fill="rgba(255,235,190,0.7)"/>
      ))}
      <rect x="60" y="50" width="200" height="70" fill="#1e1208"/>
      <rect x="72" y="38" width="32" height="52" fill="#1e1208"/>
      <rect x="216" y="38" width="32" height="52" fill="#1e1208"/>
      {([72,80,88,96,104,216,224,232,240] as number[]).map((x,i)=>(
        <rect key={i} x={x} y={34} width="6" height="8" fill="#1e1208"/>
      ))}
      <polygon points="88,34 88,20 80,28 96,28" fill="#1e1208"/>
      <polygon points="232,34 232,20 224,28 240,28" fill="#1e1208"/>
      {([[83,56],[103,56],[123,56],[143,56],[163,56],[183,56],[203,56],
        [83,70],[103,70],[123,70],[143,70],[163,70],[183,70],[203,70]] as [number,number][]).map(([x,y],i)=>(
        <rect key={i} x={x} y={y} width="8" height="7" rx="1"
          fill={i%3===0?"rgba(240,175,50,0.75)":"rgba(240,160,40,0.25)"}/>
      ))}
      <rect x="0" y="102" width="320" height="18" fill="#120a04"/>
      {([10,50,90,130,170,210,250,290] as number[]).map((x,i)=>(
        <rect key={i} x={x} y={102} width={i%3===0?18:12} height={i%3===0?10:7} rx="1" fill="#0e0804"/>
      ))}
      <text x="10" y="116" fontFamily="monospace" fontSize="9" fill="rgba(240,175,50,0.55)">Madrid · Palacio Real</text>
    </svg>
  );
}

export function SceneSeville() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <rect width="320" height="120" fill="#120c06"/>
      <defs>
        <linearGradient id="sevSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgba(180,60,10,0.55)"/>
          <stop offset="60%" stopColor="rgba(80,20,5,0.3)"/>
          <stop offset="100%" stopColor="transparent"/>
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="320" height="80" fill="url(#sevSky)"/>
      {([[30,10],[80,6],[200,9],[270,13],[310,5],[45,20],[160,4]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.8" fill="rgba(255,235,190,0.65)"/>
      ))}
      <rect x="132" y="8" width="26" height="112" fill="#1c1008"/>
      <rect x="130" y="6" width="30" height="14" fill="#221408"/>
      <rect x="128" y="2" width="34" height="8" fill="#221408"/>
      {([16,26,36,46,56,66,76,88] as number[]).map((y,i)=>(
        <rect key={i} x={141} y={y} width="8" height="8" rx="4"
          fill={i%2===0?"rgba(240,170,40,0.6)":"rgba(240,150,30,0.18)"}/>
      ))}
      <rect x="58" y="52" width="204" height="68" fill="#160e06"/>
      <polygon points="58,52 160,26 262,52" fill="#1a1008"/>
      <circle cx="160" cy="52" r="11" fill="none" stroke="rgba(240,170,40,0.35)" strokeWidth="1.5"/>
      <circle cx="160" cy="52" r="5" fill="rgba(240,170,40,0.18)"/>
      <path d="M108,120 L108,84 Q118,73 128,84 L128,120" fill="rgba(240,170,40,0.10)"/>
      <path d="M192,120 L192,84 Q202,73 212,84 L212,120" fill="rgba(240,170,40,0.10)"/>
      <text x="10" y="116" fontFamily="monospace" fontSize="9" fill="rgba(240,175,50,0.55)">Sevilla · La Giralda</text>
    </svg>
  );
}

export function SceneFlamenco() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <rect width="320" height="120" fill="#0e0806"/>
      <ellipse cx="160" cy="115" rx="85" ry="22" fill="rgba(224,85,32,0.22)"/>
      <polygon points="118,0 202,0 235,120 85,120" fill="rgba(240,170,40,0.06)"/>
      <ellipse cx="160" cy="53" rx="11" ry="20" fill="#1a0f08"/>
      <circle cx="160" cy="28" r="8" fill="#1a0f08"/>
      <path d="M160,44 Q138,28 128,14" stroke="#1a0f08" strokeWidth="4.5" fill="none" strokeLinecap="round"/>
      <path d="M128,14 Q122,8 124,4" stroke="#1a0f08" strokeWidth="3" fill="none" strokeLinecap="round"/>
      <path d="M160,48 Q182,42 196,37" stroke="#1a0f08" strokeWidth="4.5" fill="none" strokeLinecap="round"/>
      <path d="M154,68 Q138,92 126,120 L194,120 Q182,92 166,68 Z" fill="#2a1008"/>
      <path d="M128,120 Q145,100 153,84" stroke="rgba(180,35,15,0.6)" strokeWidth="2.5" fill="none"/>
      <path d="M192,120 Q175,100 167,84" stroke="rgba(180,35,15,0.6)" strokeWidth="2.5" fill="none"/>
      {([-35,-18,0,18,35] as number[]).map((a,i)=>(
        <line key={i} x1="196" y1="37"
          x2={196+20*Math.cos((a-65)*Math.PI/180)}
          y2={37+20*Math.sin((a-65)*Math.PI/180)}
          stroke="rgba(240,175,50,0.5)" strokeWidth="1.3"/>
      ))}
      <circle cx="128" cy="14" r="2.5" fill="rgba(240,175,50,0.7)"/>
      <circle cx="196" cy="37" r="2" fill="rgba(240,175,50,0.5)"/>
      <text x="10" y="116" fontFamily="monospace" fontSize="9" fill="rgba(240,175,50,0.55)">Andalucía · Flamenco</text>
    </svg>
  );
}

export function SceneRio() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <defs>
        <linearGradient id="rioSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#061a10"/>
          <stop offset="100%" stopColor="#041208"/>
        </linearGradient>
      </defs>
      <rect width="320" height="120" fill="url(#rioSky)"/>
      <rect x="0" y="90" width="320" height="30" fill="#041010"/>
      {([[15,96],[55,92],[100,95],[145,91],[200,94],[255,92],[300,96]] as [number,number][]).map(([x,y],i)=>(
        <line key={i} x1={x} y1={y} x2={x+16} y2={y} stroke="rgba(62,200,128,0.18)" strokeWidth="1.2"/>
      ))}
      <polygon points="148,90 186,18 224,90" fill="#0c2018"/>
      <polygon points="143,90 178,32 214,90" fill="#0e2518"/>
      <rect x="179" y="10" width="6" height="20" fill="#163520"/>
      <line x1="166" y1="18" x2="198" y2="18" stroke="#163520" strokeWidth="4"/>
      <circle cx="182" cy="9" r="3.5" fill="#163520"/>
      <circle cx="182" cy="9" r="7" fill="none" stroke="rgba(62,200,128,0.28)" strokeWidth="1.2"/>
      {([[95,72],[107,67],[119,74],[131,70],[143,76],[235,72],[245,67],[256,73],[267,69],[277,75]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="1.2" fill={`rgba(62,200,128,${0.25+0.25*(i%3)/2})`}/>
      ))}
      {([[28,10],[72,6],[205,8],[280,13],[312,5]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.8" fill="rgba(240,255,235,0.55)"/>
      ))}
      {([[40,24],[46,19],[52,24],[46,29]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="1.1" fill="rgba(210,255,225,0.75)"/>
      ))}
      <text x="10" y="114" fontFamily="monospace" fontSize="9" fill="rgba(62,200,128,0.55)">Rio de Janeiro · Cristo Redentor</text>
    </svg>
  );
}

export function SceneSaoPaulo() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <rect width="320" height="120" fill="#050e08"/>
      <ellipse cx="160" cy="125" rx="210" ry="55" fill="rgba(62,200,128,0.08)"/>
      {([
        [8,38,22,82],[33,22,20,98],[56,48,24,72],[82,28,18,92],[104,40,26,80],
        [132,18,22,102],[156,33,24,87],[180,26,20,94],[204,43,22,77],[228,30,24,90],
        [252,46,22,74],[276,36,20,84],[298,28,18,92],
      ] as [number,number,number,number][]).map(([x,y,w,h],i)=>(
        <rect key={i} x={x} y={y} width={w} height={h} fill={i%4===0?"#0d2016":"#081810"}/>
      ))}
      {([[8,38],[33,22],[82,28],[132,18],[180,26],[228,30]] as [number,number][]).map(([bx,by],bi)=>(
        <g key={bi}>
          {[0,1,2,3,4,5].map(row=>(
            [0,1,2].map(col=>(
              <rect key={`${row}-${col}`} x={bx+2+col*6} y={by+4+row*9} width="4" height="5" rx="0.8"
                fill={(bi*7+row*3+col)%5<3?"rgba(62,200,128,0.45)":"rgba(240,220,120,0.12)"}/>
            ))
          ))}
        </g>
      ))}
      <rect x="0" y="98" width="320" height="5" fill="#081810"/>
      <rect x="0" y="98" width="320" height="1" fill="rgba(62,200,128,0.18)"/>
      <text x="10" y="115" fontFamily="monospace" fontSize="9" fill="rgba(62,200,128,0.55)">São Paulo · Skyline</text>
    </svg>
  );
}

export function SceneSalvador() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      style={{width:'100%',height:'100%',display:'block'}}>
      <defs>
        <linearGradient id="salSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#061410"/>
          <stop offset="100%" stopColor="#0a1c14"/>
        </linearGradient>
      </defs>
      <rect width="320" height="120" fill="url(#salSky)"/>
      <rect x="0" y="82" width="320" height="38" fill="#041010"/>
      {([[0,90],[42,86],[86,90],[134,85],[184,89],[234,86],[282,90]] as [number,number][]).map(([x,y],i)=>(
        <path key={i} d={`M${x},${y} Q${x+20},${y-5} ${x+42},${y}`}
          stroke="rgba(62,200,128,0.14)" strokeWidth="1.6" fill="none"/>
      ))}
      {([
        [28,36,34,46],[64,26,30,56],[96,40,36,42],[134,30,32,52],
        [168,44,30,38],[200,34,34,48],[236,38,32,44],[270,28,30,54],
      ] as [number,number,number,number][]).map(([x,y,w,h],c)=>(
        <rect key={c} x={x} y={y} width={w} height={h} fill={c%3===0?"#0f2318":"#0a2010"}/>
      ))}
      <rect x="145" y="8" width="22" height="32" fill="#0a2010"/>
      <polygon points="145,8 156,0 167,8" fill="#0c2412"/>
      <circle cx="156" cy="7" r="2.5" fill="rgba(62,200,128,0.35)"/>
      {([40,72,108,148,178,216,254,284] as number[]).map((x,i)=>(
        <rect key={i} x={x} y={46} width="7" height="9" rx="3.5"
          fill={`rgba(62,200,128,${0.18+i*0.04})`}/>
      ))}
      <text x="10" y="115" fontFamily="monospace" fontSize="9" fill="rgba(62,200,128,0.55)">Salvador · Pelourinho</text>
    </svg>
  );
}

export function SceneHelsinki() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{width:'100%',height:'100%',display:'block'}}>
      <defs>
        <linearGradient id="hskySky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#060C1E"/>
          <stop offset="100%" stopColor="#0A1435"/>
        </linearGradient>
      </defs>
      <rect width="320" height="120" fill="url(#hskySky)"/>
      <rect x="0" y="85" width="320" height="35" fill="#060D22"/>
      {([[10,92],[50,88],[100,92],[160,87],[220,91],[280,88]] as [number,number][]).map(([x,y],i)=>(
        <line key={i} x1={x} y1={y} x2={x+20} y2={y} stroke="rgba(33,119,221,0.15)" strokeWidth="1.2"/>
      ))}
      <rect x="115" y="40" width="90" height="45" fill="#F2F7FF" opacity="0.92"/>
      <ellipse cx="160" cy="36" rx="22" ry="18" fill="#F2F7FF" opacity="0.92"/>
      <ellipse cx="160" cy="26" rx="8" ry="6" fill="#F2F7FF" opacity="0.85"/>
      <ellipse cx="126" cy="44" rx="9" ry="7" fill="#F2F7FF" opacity="0.80"/>
      <ellipse cx="194" cy="44" rx="9" ry="7" fill="#F2F7FF" opacity="0.80"/>
      {([126,137,148,159,170,181,192] as number[]).map((x,i)=>(
        <rect key={i} x={x} y={50} width="4" height="35" fill="rgba(33,119,221,0.25)"/>
      ))}
      <rect x="108" y="84" width="104" height="4" fill="#F2F7FF" opacity="0.5"/>
      {([[20,10],[60,6],[200,8],[280,11],[40,25],[290,20]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.8" fill="rgba(200,220,255,0.7)"/>
      ))}
      <ellipse cx="160" cy="120" rx="120" ry="30" fill="rgba(33,119,221,0.08)"/>
      <text x="10" y="114" fontFamily="monospace" fontSize="9" fill="rgba(130,170,255,0.5)">Helsinki · Tuomiokirkko</text>
    </svg>
  );
}

export function SceneLake() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{width:'100%',height:'100%',display:'block'}}>
      <defs>
        <linearGradient id="lakeSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#050D1A"/>
          <stop offset="60%" stopColor="#0A1A30"/>
          <stop offset="100%" stopColor="#061422"/>
        </linearGradient>
      </defs>
      <rect width="320" height="120" fill="url(#lakeSky)"/>
      <ellipse cx="160" cy="68" rx="200" ry="30" fill="rgba(33,119,221,0.12)"/>
      <rect x="0" y="70" width="320" height="50" fill="#040C18"/>
      {([0,40,80,130,190,240,280] as number[]).map((x,i)=>(
        <path key={i} d={`M${x},${78+i%3*4} Q${x+16},${74+i%2*3} ${x+32},${78+i%3*4}`} stroke="rgba(33,119,221,0.18)" strokeWidth="1.4" fill="none"/>
      ))}
      {([[10,30],[35,20],[55,35],[75,18],[95,28],[225,22],[248,30],[268,18],[288,25],[308,32]] as [number,number][]).map(([x,y],i)=>(
        <polygon key={i} points={`${x},70 ${x-8},${y+20} ${x-4},${y+20} ${x-4},${y} ${x+4},${y} ${x+4},${y+20} ${x+8},${y+20}`} fill={i%3===0?"#0A1C2E":"#081520"}/>
      ))}
      {([155,175,195] as number[]).map((x,i)=>(
        <rect key={i} x={x} y={45} width="3" height="25" fill="rgba(220,235,255,0.2)"/>
      ))}
      <text x="10" y="115" fontFamily="monospace" fontSize="9" fill="rgba(130,170,255,0.5)">Järvi-Suomi · Finnish Lakeland</text>
    </svg>
  );
}

export function SceneSauna() {
  return (
    <svg viewBox="0 0 320 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" style={{width:'100%',height:'100%',display:'block'}}>
      <defs>
        <linearGradient id="sauSky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#060A18"/>
          <stop offset="100%" stopColor="#0A1428"/>
        </linearGradient>
      </defs>
      <rect width="320" height="120" fill="url(#sauSky)"/>
      <rect x="0" y="82" width="320" height="38" fill="#040C18"/>
      {([[0,90],[45,86],[90,90],[140,85],[200,89],[255,86],[295,90]] as [number,number][]).map(([x,y],i)=>(
        <line key={i} x1={x} y1={y} x2={x+22} y2={y} stroke="rgba(33,119,221,0.14)" strokeWidth="1"/>
      ))}
      <rect x="80" y="52" width="80" height="30" fill="#1A0E08"/>
      {([56,62,68,74] as number[]).map((y,i)=>(
        <line key={i} x1="80" y1={y} x2="160" y2={y} stroke="rgba(0,0,0,0.3)" strokeWidth="1"/>
      ))}
      <polygon points="74,52 160,52 156,38 86,38" fill="#120C06"/>
      <line x1="74" y1="52" x2="88" y2="38" stroke="rgba(0,0,0,0.5)" strokeWidth="1"/>
      <rect x="108" y="62" width="24" height="20" rx="1" fill="#0D0808"/>
      <rect x="110" y="64" width="20" height="16" rx="1" fill="rgba(200,120,40,0.15)"/>
      {([0,1,2] as number[]).map(i=>(
        <path key={i} d={`M${130+i*6},38 Q${128+i*5},30 ${132+i*6},22 Q${130+i*5},14 ${134+i*6},8`} stroke="rgba(180,180,200,0.12)" strokeWidth={3-i} fill="none"/>
      ))}
      {([190,210,232,255,278] as number[]).map((x,i)=>(
        <polygon key={i} points={`${x},82 ${x-7},${60+i%2*5} ${x+7},${60+i%2*5}`} fill="#0A1520"/>
      ))}
      {([[40,12],[70,8],[200,10],[260,6],[300,14]] as [number,number][]).map(([x,y],i)=>(
        <circle key={i} cx={x} cy={y} r="0.9" fill="rgba(200,220,255,0.6)"/>
      ))}
      <circle cx="270" cy="20" r="7" fill="rgba(230,240,255,0.15)" stroke="rgba(200,220,255,0.3)" strokeWidth="1"/>
      <text x="10" y="115" fontFamily="monospace" fontSize="9" fill="rgba(130,170,255,0.5)">Suomi · Sauna by the lake</text>
    </svg>
  );
}

export type Language = 'Spanish' | 'Portuguese' | 'Finnish';

export function getScenes(language: Language): [() => React.ReactElement, () => React.ReactElement, () => React.ReactElement] {
  if (language === 'Portuguese') return [SceneRio, SceneSaoPaulo, SceneSalvador];
  if (language === 'Finnish') return [SceneHelsinki, SceneLake, SceneSauna];
  return [SceneMadrid, SceneSeville, SceneFlamenco];
}
